/**
 * G1 — legacy top-level `shipping-methods` (delivery policy) now lives as an
 * Account hub card (`account-settings` + `tab=deliveryPolicy`), not a resolved
 * dashboard section. Pure remap for URL bootstrap + localStorage restore.
 */

/** Canonical Account hub section that owns Delivery policy. */
export const LEGACY_SHIPPING_METHODS_REMAP_SECTION = 'account-settings' as const;

/** Account Settings tab that hosts Delivery policy content. */
export const LEGACY_SHIPPING_METHODS_REMAP_TAB = 'deliveryPolicy' as const;

/**
 * Remaps a dashboard section key (URL bootstrap / saved localStorage) so
 * callers never leave `shipping-methods` as the resolved active section.
 * Unknown keys pass through unchanged.
 */
export function remapLegacyDashboardSectionKey(section: string): string {
  if (section === 'shipping-methods') {
    return LEGACY_SHIPPING_METHODS_REMAP_SECTION;
  }
  return section;
}

/**
 * G1 — arm one-shot Account hub `tab=deliveryPolicy` inject from stale
 * `admin_active_section_*=shipping-methods` **only** when storage is the
 * winning mount seed.
 *
 * Mount precedence is URL seed > localStorage > mission-control. If a URL
 * seed already won, do **not** arm the storage remap — otherwise a stale
 * shipping-methods localStorage entry clobbers e.g. `?section=products`.
 */
export function shouldArmShippingMethodsStorageRemap(input: {
  readonly savedWasLegacyShippingMethods: boolean;
  readonly urlSeedSection: string | null;
}): boolean {
  return input.savedWasLegacyShippingMethods && input.urlSeedSection === null;
}